export default __webpack_public_path__ + "static/media/Document.13454687.svg";